import MUITableCell from "@mui/material/TableCell";
import styled from "@emotion/styled";

export const TableCell = styled(MUITableCell)`
  font-size: 13px;
  padding: 3.5px 24px;
  height: 40px;
`;
